// extracted by mini-css-extract-plugin
export default {"firstTimeContainer":"hBr0emQzy0s4Shn9Q_jK","secondHeading":"bgkGEKGkS9Y2GSWmuKGU","divider":"susR6HFYbvNCaQvDyDAY","switchAccountsContainer":"WpFCz_t4T7E6tUqpxCj8"};